import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

export const useCancelUkAoChangeMutation = (): MutationState => {
  return useMutation({
    request: {
      type: 'rest',
      method: 'post',
      target: 'companyAPI',
      endpoint: '/account-ownership/uk/cancel-request',
    },
    options: {
      onSuccess: ({ client }) => {
        client.invalidateQueries({
          queryKey: ['aoChangeEligibility'],
        });
        client.invalidateQueries({
          queryKey: ['getAoChangeRequest'],
        });
      },
    },
  });
};
